module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "bigDiv"
  }, [_c('swiper', {
    ref: "cateSwiper",
    attrs: {
      "loop": "",
      "auto": "",
      "interval": 5000,
      "list": _vm.swImgUrlList,
      "show-desc-mask": false,
      "dots-position": "center"
    },
    on: {
      "on-get-height": _vm.parCatyUpdateHeight
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "downloadDiv",
    on: {
      "click": _vm.downloadApp
    }
  }, [_c('span', [_vm._v("立即下载")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "bgDiv",
    attrs: {
      "id": "bgDiv"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bgImg",
    attrs: {
      "id": "bgImg"
    }
  }, [_c('img', {
    attrs: {
      "src": require('../../assets/images/Group 540@2x.png')
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c540b94"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/invite/invite_in.vue
// module id = 447
// module chunks = 1